<script>
import Addresses from "@/components/_Shared/Addresses/Index";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    Addresses
  },
  computed: {
    ...mapState("newOrder", ["address", "user"])
  },

  methods: {
    ...mapActions("newOrder", ["setAddress"]),
    selectAddress(address) {
      this.$emit("scrollTo");
      this.setAddress(address);
    }
  }
};
</script>

<template>
  <div class="section">
    <div class="section-title">
      AGENDE SUA PRÓXIMA LIMPEZA
      <hr />
    </div>
    <span class="mt-10 mb-10">Qual endereço que ela será feita?</span>

    <transition name="fade" mode="out-in">
      <addresses
        :accountable="user.accountable"
        :class="{ 'passed-on': address }"
        :selected="address"
        @selected="selectAddress"
      />
    </transition>
  </div>
</template>

<style scoped>
@media (max-width: 480px) {
  span {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/Address.vue